import RendererTypesEnum from '~/modules/catalog/category/components/filters/renderer/RendererTypesEnum';
import type { FilterConfigInterface } from '~/modules/catalog/category/config/FiltersConfig';
import { productAdditionalFields } from '~/modules/GraphQL/customQueries/fragments/fragmentProductAdditionalFields';

export enum FilterTypeEnum {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  SWATCH_COLOR = 'swatch_color',
  YES_NO = 'yes_no',
  RANGE_SLIDER = 'range_slider',
}

export enum SignsEnum {
  ZLOTY = 'zł',
  PERCENT = '%',
  KG = 'kg',
  LITRE = 'l',
  MM = 'mm',
  CM = 'cm',
  M = 'm',
  M2 = 'm²',
  M3 = 'm³',
  G = 'g',
  MG = 'mg',
  ML = 'ml',
  KM = 'km',
  SZT = 'szt',
}
/**
 * Override this to add/modify filters renderers and data
 *
 * @attrCode: Magento attribute code
 * @type: internal filter type
 * @component: filter renderer component
 * @disabled: flag to disable filter on the front; disabled filter will be not rendered
 * @sign: string to show near inputs
 */
export default function config(): FilterConfigInterface[] {
  const additionalFields = productAdditionalFields.map((field) => ({
    attrCode: field,
  }));
  return [
    {
      attrCode: 'price',
      type: FilterTypeEnum.RANGE_SLIDER,
      component: RendererTypesEnum.RANGE_SLIDER,
      sign: SignsEnum.ZLOTY,
    },
    {
      attrCode: 'bestseller',
    },
    {
      attrCode: 'new',
    },
    {
      attrCode: 'purpose',
    },
    {
      attrCode: 'korzysci_stosowania',
    },
    {
      attrCode: 'Regeneracja_upraw',
    },
    {
      attrCode: 'aktywacja_upraw',
    },
    {
      attrCode: 'Budowanie_plonu_i_jakosci',
    },
    {
      attrCode: 'zwiekszanie_odpornosci_upraw',
    },
    {
      attrCode: 'forma_pakowania',
    },
    {
      attrCode: 'forma_transportu',
    },

    ...additionalFields,
  ];
}
